<template>
    <div>
      	<div class="container-fluid" v-if="profile">
		  	<form v-on:submit.prevent>
				<div class="form-group row">
					<label class="col-sm-3 col-form-label">
						Advertiser Name
						<sup>*</sup>
					</label>
					<div class="col-sm-7 pr-5">
						<multiselect v-if="isSelectable"
							v-model="profile.selected_profile"
							:options="AMCList"
							label="customer_canonical_name"
							:searchable="true"
							ref="multiselect"
							track-by="instance_id"
							open-direction="bottom"
							placeholder="AMC"
							class="form-control multi-dropdown select_filter"
							selectLabel
							deselectLabel
							selectedLabel
							autocomplete="off"
							style="max-height: 40px"
							:multiple="false"
							id="customer_canonical_name"
							:taggable="false"
							@select="AMCChanged($event)"
						>
						</multiselect>
						<input v-else
							v-on:keydown.enter.prevent
							type="text"
							name="customer_canonical_name"
							v-model="profile.selected_profile.customer_canonical_name"
							class="form-control"
							id="customer_canonical_name"
							placeholder="Instance Name"
							autocomplete="off"
							disabled="true"
						/>
					</div>
				</div>
				<div class="form-group row" v-if="profile.selected_profile.customer_canonical_name">
					<label class="col-sm-3 col-form-label">Instance Name</label>
					<div class="col-sm-7 pr-5">
						<input
							v-on:keydown.enter.prevent
							type="text"
							name="instance_name"
							v-model="profile.selected_profile.instance_name"
							class="form-control"
							id="instance_name"
							placeholder="Instance Name"
							autocomplete="off"
							disabled="true"
						>
					</div>
				</div>
				<div class="form-group row" v-if="profile.selected_profile.customer_canonical_name">
					<label class="col-sm-3 col-form-label">Instance Id</label>
					<div class="col-sm-7 pr-5">
						<input
							v-on:keydown.enter.prevent
							type="text"
							name="instance_id"
							v-model="profile.selected_profile.instance_id"
							class="form-control"
							id="instance_id"
							placeholder="Instance Id"
							autocomplete="off"
							disabled="true"
						>
					</div>
				</div>
				<div class="form-group row" v-if="profile.selected_profile.customer_canonical_name">
					<label class="col-sm-3 col-form-label">Active</label>
					<div class="col-sm-7 pr-5">
						<input
							v-on:keydown.enter.prevent
							type="text"
							name="active"
							v-model="active"
							class="form-control"
							id="active"
							placeholder="Active"
							autocomplete="off"
							disabled="true"
						>
					</div>
				</div>
		  	</form>
		</div>
	</div>
</template>

<script>

  import Multiselect from "vue-multiselect";
  import moment from "moment";
  import datePicker from 'vue-bootstrap-datetimepicker';

  export default {
  	name: "AMCAccountData",
	components:{Multiselect, moment, datePicker},
	props:["profile", "index", "AMCList", "noDateForActiveFalse"],
	data(){
		return{
			client_added:true,
			isDataPresent:false,
			isAMCNamePresent:false,
			isSubmitted:false,
			isSelectable: true,
			active: this.profile.selected_profile.active ? 'True' : 'False'
		}
	},
	computed:{
		min_date(){
			return  moment().format("YYYY-MM-DD");
		},
	},
	watch:{
	},
	methods:{
	},
}
</script>
